import styles from './Footer.module.scss'

export const Footer = () => {
	return <div className={styles.container}>(c) Diana Klymchyk, 2024</div>
}
